import queryString from "query-string";

class ComScoreAnalytics {
  constructor(options) {
    this.defaultParams = options.defaultParams || {};
    this.baseUrl = options.baseUrl;
    this.baseName = options.baseName;
    this.debug = options.debug || false;
  }

  submit(params) {
    const fullParameters = Object.assign({}, this.defaultParams, params);
    const url = `${this.baseUrl}?${queryString.stringify(fullParameters)}`;

    if (this.debug) {
      console.info("Tracking:", fullParameters); // eslint-disable-line no-console
      return;
    }

    window.udm_(url); // eslint-disable-line no-underscore-dangle
  }

  track(name, section, title, type = "hidden") {
    this.submit({
      name: `${this.baseName}.${name}`,
      nos_labs_section: section,
      nos_title: title,
      ns_type: type
    });
  }
}

export default new ComScoreAnalytics({
  baseUrl: "https://sb.scorecardresearch.com/b",
  debug: process.env.NODE_ENV === "development",
  baseName: "labs.op3.social-credit-score",
  defaultParams: {
    c1: 2,
    c2: 17827132,
    ns_site: "po-totaal",
    potag1: "nosop3",
    potag2: "nosop3",
    potag3: "nos",
    potag4: "nos",
    potag5: "programma",
    potag6: "geen",
    potag7: "npo3",
    potag8: "site",
    potag9: "site",
    nos_project: "nos-labs",
    nos_event: "social-credit-score"
  }
});



// WEBPACK FOOTER //
// ./src/services/tracking.js